export type PopularTravelPostsLinkTypes = {
  [key in DomainKeys]: {
    seeAllButtonLink: string
    postSlugLink: string
  }
}

export type DomainKeys = 'tr-tr' | 'ae-ar' | 'sa-ar' | 'sa-en' | 'ae-en'

export const BlogPaths = {
  enuygun: 'bilgi',
  wingie: 'blog',
}

export const PopularTravelPostsLinks: PopularTravelPostsLinkTypes = {
  'tr-tr': {
    seeAllButtonLink: 'https://www.enuygun.com/bilgi/konu/seyahat-yazilari/',
    postSlugLink: 'https://www.enuygun.com/bilgi/${slug}/',
  },
  'ae-ar': {
    seeAllButtonLink: 'https://www.wingie.ae/blog/topic/travel-posts/',
    postSlugLink: 'https://www.wingie.ae/blog/${slug}/',
  },
  'sa-ar': {
    seeAllButtonLink: 'https://sa.wingie.com/sa-ar/blog/topic/travel-posts/',
    postSlugLink: 'https://sa.wingie.com/blog/${slug}/',
  },
  'sa-en': {
    seeAllButtonLink: 'https://sa.wingie.com/en/blog/topic/travel-posts/',
    postSlugLink: 'https://sa.wingie.com/en/blog/${slug}/',
  },
  'ae-en': {
    seeAllButtonLink: 'https://www.wingie.ae/en/blog/topic/travel-posts/',
    postSlugLink: 'https://www.wingie.ae/en/blog/${slug}/',
  },
}
